import React from 'react';
import { Alert } from 'reactstrap';

export default function GraphQLErrors({ error }) {
  const errors = error ? error.graphQLErrors.map(e => e.message) : [];

  return error ? <Alert color="danger">{errors}</Alert> : null;
}
